<template>
  <el-form
    v-loading="loading"
    ref="ruleFormRef"
    :model="ruleForm"
    :rules="rules"
    label-width="90px"
    class="demo-ruleForm scroll_y"
    size="large"
    status-icon
  >
    <el-form-item label="名称" prop="title">
      <el-input
        v-model="ruleForm.title"
        placeholder="请填写名称"
        class="middle_input"
      />
    </el-form-item>
    <el-row>
      <el-col :span="12">
        <el-form-item label="所属类别" prop="category">
          <el-select
            v-model="ruleForm.category"
            class="m-2 small_input"
            placeholder="请选择所属类别"
            @change="searchData"
          >
            <el-option
              v-for="item in $constGlobal.categoryList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select> </el-form-item
      ></el-col>
      <el-col :span="12">
        <el-form-item label="排序值" prop="orderIndex">
          <el-tooltip
            class="item"
            effect="dark"
            content="只能输入数字(整数)且必须大于0,从小到大依次排序"
            placement="top"
          >
            <el-input
              class="small_input"
              type="number"
              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
              maxlength="9"
              v-model="ruleForm.orderIndex"
              placeholder="大于0的整数"
            />
          </el-tooltip> </el-form-item
      ></el-col>
    </el-row>
    <el-form-item label="描述" prop="description">
      <WangEditor
        :isDecode="false"
        v-if="editorShow"
        :content="ruleForm.description"
        @changeContent="setDescription"
      />
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button v-if="!submitDisabled" type="primary" size="large" @click="submitForm(ruleFormRef)"
       :disabled = "submitDisabled">提交保存</el-button
    >
    <el-button type="primary" size="large" loading v-else>提交中</el-button>
  </div>
</template>

<script>
import {
  getEntryGuideDetail,
  createEntryGuide,
  updateEntryGuide,
} from "network/examinationGuide.js";
import WangEditor from "components/wangEditor/WangEditor.vue";
import { toRefs, reactive, ref, unref, onMounted, toRaw } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { textFilter, isEditorNull } from "common/utils.js";
export default {
  name: "AddExaminationGuide",
  components: { WangEditor },
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editId: Number,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const data = reactive({
      loading: false,
      editorShow: false,
      ruleForm: {
        id: null,
        category: null,
        title: null,
        description: "",
        orderIndex: null,
      },
      rules: {
        title: [
          { required: true, message: "请填写名称" },
          { min: 2, max: 8, message: "名称为2-8字" },
        ],
        category: [
          {
            required: true,
            message: "请选择所属类别",
            trigger: "change",
          },
        ],
        orderIndex: [
          {
            required: true,
            message: "请填写排序值",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "请填写描述",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              let isEmpty = isEditorNull(textFilter(value));
              if (isEmpty) {
                callback(new Error("请填写描述!"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      submitDisabled:false
    });

    //编辑报考指南详情
    if (props.editId > 0) {
      data.loading = true;
      getEntryGuideDetail(props.editId)
        .then((result) => {
          if (result && result.code == 1) {
            data.loading = false;
            data.editorShow = true;
            data.ruleForm = result.result;
            data.ruleForm.id = props.editId;
          } else {
            data.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      data.editorShow = true;
    }

    //获取富文本编辑器传过来的
    const setDescription = (val) => {
      if (val) {
        // data.ruleForm.description = encodeURIComponent(val);
        data.ruleForm.description = val;
        ruleFormRef.value.clearValidate("description"); //移除校验结果
      }
    };
    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.submitDisabled = true;
          updataAdd(data.ruleForm).then(() => {
            data.submitDisabled = false;
          });
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    async function updataAdd(data) {
      let result = "";
      if (props.editId > 0) {
        result = await updateEntryGuide(data);
      } else {
        result = await createEntryGuide(data);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
                 });
            emit("close-dialog");
            emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
               });
      }
    }
    onMounted(() => {});
    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
    };
    return {
      setDescription,
      submitForm,
      ruleFormRef,
      resetForm,
      ...toRefs(data),
    };
  },
  methods: {
    searchData() {},
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 540px;
}
</style>

